<div class="container">
    <sh-grid class="searchBar">
        <div columns="2" class="search">
            <span>
                <sh-input-text label='Search' id="searchText" [(value)]="searchWord" (click)="isReset($event)"
                    (keyup)="search($event)">
                </sh-input-text>
            </span>
            <!-- <sh-search  (keyup)="search()" label="Search"></sh-search> -->
        </div>
        <div column="8">
            <sh-accordion id="extensionFilter" label="{{currentApp}}"
                (click)="doprdownExpansions.application=!doprdownExpansions.application"
                [expanded]="doprdownExpansions.application">
                <sh-text class="handSelector" id="extensionCheckbox" *ngFor="let app of applications;"
                    (click)="currentApp=app.name;currentAppId=app._id;getGroups(app._id, app.name)"
                    #extensionCheckboxes>{{app.name}}
                </sh-text>
            </sh-accordion>
        </div>
        <div column="4">

        </div>
        <div column="8">
            <sh-button label='Add' *ngIf="isSuperUser" [disabled]="nogroups"
                onclick="document.querySelector('#addGroupModal').visible = true">
            </sh-button>
            <sh-notifications class="mg-notify">
                <sh-notification-item  [visible]="isShowNotificationAlert" 
                  type="alert"
                  label="Alert">
                  {{showAlertMessage}}
                </sh-notification-item>

                <sh-notification-item  [visible]="isShowNotificationSuccess"
                  type="confirmation"
                  label="Success">
                  {{showSuccessMessage}}
                </sh-notification-item>

                <sh-notification-item  [visible]="isShowNotificationError"
                type="error"
                label="Error Occured">
                {{showErrorMessage}}
              </sh-notification-item>

            </sh-notifications>
        </div>
       
    </sh-grid>
    <div class="user-data-div">
        <sh-grid>
            <div columns="10" class="userData">
                <sh-table freeze>
                    <!-- a table row can be placed in the 'header' slot of the table -->
                    <sh-table-row slot="header">
                        <!-- table-heads are used inside header rows -->
                        <!-- (click)="sortUser('userGroup')" -->
                        <sh-table-head columns="5">Group</sh-table-head>
                        <sh-table-head columns="20">Tokens</sh-table-head>
                        <sh-table-head columns="5">Actions</sh-table-head>
                    </sh-table-row>
                    <sh-table-row *ngFor="let usergroup of modifyUserGroups">
                        <!-- use 'columns', 'col-m' and 'col-s' for defining the span of a cell for diffferent breakpoints -->
                        <sh-table-cell columns="5">
                            {{usergroup.group}}
                        </sh-table-cell>
                        <sh-table-cell columns="20">
                            <p>{{generateData(usergroup.tokens)}}</p>
                        </sh-table-cell>
                        <sh-table-cell columns="5">
                            <div class="display-flex">
                                <sh-icon icon="edit" [disabled]="usergroup.applicationName.length > 1"
                                    *ngIf="isSuperUser || isAdminUser" (click)="initModify(usergroup)"></sh-icon>
                                <sh-icon icon="delete" *ngIf="isSuperUser || isAdminUser"
                                    [disabled]="usergroup.applicationName.length > 1"
                                    (click)="deleteConfirmation(usergroup)">
                                </sh-icon>
                            </div>
                        </sh-table-cell>
                    </sh-table-row>
                    <sh-table-row
                        *ngIf="(modifyUserGroups == undefined || modifyUserGroups.length == 0) && !noAccessToApplication">
                        <sh-table-cell>No Groups found!</sh-table-cell>
                    </sh-table-row>
                    <sh-table-row *ngIf="noAccessToApplication">
                        <sh-table-cell>You do not have access to this application!</sh-table-cell>
                    </sh-table-row>
                </sh-table>
            </div>
        </sh-grid>
    </div>

    <!-- modals -->

    <sh-modal id="addGroupModal" label='Add Group' modal-height='300px' modal-width='600px'>
        <sh-text size='title-2' color="primary">Enter a name for the User Group</sh-text>
        <sh-input-text label='Group Name' [error]="groupExists" error-message="Group Name Exists" [(value)]="newGroup"
            (keyup)="setAddGroup($event)"></sh-input-text>
        <br>
        <sh-input-text disabled label='Application Name' [(value)]="currentApp"></sh-input-text>
        <sh-button color='secondary' slot='footer' label='Cancel'
            onclick="document.querySelector('#addGroupModal').visible = false" (click)="newGroup = ''"></sh-button>
        <sh-button slot='footer' label='Save' onclick="document.querySelector('#addGroupModal').visible = false"
            [disabled]="groupExists || newGroup.length == 0" (click)="addNewGroup(newGroup, currentAppId)">
        </sh-button>
    </sh-modal>

    <sh-modal id="delete-confirmation" type='alert' label='Delete Group' modal-height='220px' modal-width='450px'>
        <sh-text p>Are you sure you want to delete the group - {{groupToDelete.group}}?</sh-text>
        <sh-text p>Users assigned to group : {{userCount}}</sh-text>
        <sh-text *ngIf="userCount>0" p>Users associated to group will be removed.</sh-text>
        <sh-button color='tertiary' slot='footer' label='Cancel'
            onclick="document.getElementById('delete-confirmation').removeAttribute('visible')" id="cancelDelete">
        </sh-button>
        <sh-button color='tertiary' slot='footer' label='Delete'
            onclick="document.getElementById('delete-confirmation').removeAttribute('visible')"
            (click)="deleteGroup(currentAppId)" id="deleteEntireAsset">
        </sh-button>
    </sh-modal>

    <sh-modal id="EmailExistsPopup" type='error' label='Error' modal-height='184px' modal-width='450px'>
        <sh-text p>Email id you entered exists</sh-text>
        <sh-button color='tertiary' slot='footer' label='OK'
            onclick="document.getElementById('EmailExistsPopup').removeAttribute('visible')">
        </sh-button>
    </sh-modal>
    <sh-modal id="SuccessPopup" type='Success' label='Success' modal-height='184px' modal-width='450px'>
        <sh-text p>{{apiReturnMessage}}</sh-text>
        <sh-button color='tertiary' slot='footer' label='OK'
            onclick="document.getElementById('SuccessPopup').removeAttribute('visible')">
        </sh-button>
    </sh-modal>
    <sh-modal id="FailurePopup" type='Error' label='Error' modal-height='184px' modal-width='450px'>
        <sh-text p>{{apiReturnMessage}}</sh-text>
        <sh-button color='tertiary' slot='footer' label='OK'
            onclick="document.getElementById('FailurePopup').removeAttribute('visible')">
        </sh-button>
    </sh-modal>

    <!-- modify modal -->
    <sh-modal id="modifyGroup" sticky label="Modify Group" modal-height='60vh' modal-width='800px'>
        <div columns="12" class="userGroup">
            <span>
                <sh-text>{{group.group}}</sh-text>
            </span>
        </div>

        <div class="userGroup">
            <span>
                <sh-text>Tokens</sh-text>
            </span>
            <sh-grid fit-content="true">

                <div columns="4" col-m="12" col-s="12">
                    <sh-accordion label="View" (click)="ViewExpanded=!ViewExpanded" [expanded]="ViewExpanded">
                        <sh-checkbox id="extensionCheckbox" *ngFor="let i1 of permission" [label]="i1"
                            [active]="checkedPermissionView.includes(i1)"
                            (click)="selection(i1,'View');ViewAccordianOpen()" #ViewCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>
                <div columns="4" col-m="12" col-s="12">
                    <sh-accordion label="Upload" (click)="UploadExpanded=!UploadExpanded" [expanded]="UploadExpanded">
                        <sh-checkbox id="extensionCheckbox" *ngFor="let i2 of permission" [label]="i2"
                            [active]="checkedPermissionUpload.includes(i2)"
                            (click)="selection(i2,'Upload');UploadAccordianOpen()" #UploadCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>
                <div columns="4" col-m="12" col-s="12">
                    <sh-accordion label="Delete" (click)="DeleteExpanded=!DeleteExpanded" [expanded]="DeleteExpanded">
                        <sh-checkbox id="extensionCheckbox" *ngFor="let i3 of permission" [label]="i3"
                            [active]="checkedPermissionDelete.includes(i3)"
                            (click)="selection(i3,'Delete');DeleteAccordianOpen()" #DeleteCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>
                <div columns="4" col-m="12" col-s="12">
                    <sh-accordion label="Download" (click)="DownloadExpanded=!DownloadExpanded"
                        [expanded]="DownloadExpanded">
                        <sh-checkbox id="extensionCheckbox" *ngFor="let i4 of permission" [label]="i4"
                            [active]="checkedPermissionDownload.includes(i4)"
                            (click)="selection(i4,'Download');DownloadAccordianOpen()" #DownloadCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>
                <div columns="4" col-m="12" col-s="12">
                    <sh-accordion label="Modify" (click)="ModifyExpanded=!ModifyExpanded" [expanded]="ModifyExpanded">
                        <sh-checkbox id="extensionCheckbox" *ngFor="let i5 of permission" [label]="i5"
                            [active]="checkedPermissionModify.includes(i5)"
                            (click)="selection(i5,'Modify');ModifyAccordianOpen()" #ModifyCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>

            </sh-grid>
        </div>
        <div columns="10" class="display-flex flex-wrap-wrap">
            <!-- <sh-tag label="{{item.name}}" *ngFor="let item of selectedBusinessFolders"
                (closed)="onSelectionChange(item,1)" removable class="selectedFoldersTag"></sh-tag> -->
        </div>
        <sh-button color='secondary' slot='footer' class="actionButtons" label='Cancel'
            (click)="initialiseUser('modifyGroup')">
        </sh-button>
        <sh-button color='Primary' slot='footer' class="actionButtons" label='Save'
            (click)="modifyPermissions(currentAppId)"></sh-button>
    </sh-modal>

</div>